import { apiSlice } from '../../apiSlice';

export const unitApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['Units'],
    endpoints: builder => ({     
        getUnitById: builder.query({
            query: (args) => {
                const unitId = args
                return {
                    url: `/Units/${unitId}`,
                }
            },
            providesTags: ["Units"]
        }),
        getUnitsByAccount: builder.query({
            query: (args) => {
                const accountId = args
                return {
                    url: `Units?Account.AccountId=eq(${accountId})&top=1000`
                }
            },
            providesTags: ["Units"]
        }),
        postUnit: builder.mutation({
            query: unit => ({
                url: '/Units',
                method: 'POST',
                body: {...unit},
            }),
            invalidatesTags: ["Units","Sensors"],
            transformResponse: (response, meta) => {
                // Access the Location header
                const locationHeader = meta?.response?.headers.get('Location');
                // Return the original response and the extracted ID
                return { data: response, location: locationHeader };
            },
        }),
        updateUnit: builder.mutation({
            query: unit => ({
                url: `/Units/${unit.UnitId}`,
                method: 'PATCH',
                body: {...unit},
            }),
            invalidatesTags: ["Units","Sensors"],
        }),
        postUnitTag: builder.mutation({
            query: ({ UnitId, Text }) => ({
              url: `/Units/${UnitId}/Tag`,
              method: 'POST',
              body: { Text },
            }),
            invalidatesTags: ["Units", "Sensors"]
        }),
        deleteUnitTag: builder.mutation({
            query: ({ UnitId, Text }) => ({
              url: `/Units/${UnitId}/Tag?tag=${encodeURIComponent(Text)}`, // Encode `Text` in the query parameter
              method: 'DELETE',
            }),
            invalidatesTags: ["Units"]
          }),
    })
})

export const {
    useGetUnitByIdQuery,
    useLazyGetUnitByIdQuery,
    useGetUnitsByAccountQuery,
    usePostUnitMutation,
    useUpdateUnitMutation,
    usePostUnitTagMutation,
    useDeleteUnitTagMutation
} = unitApiSlice